module.exports = __webpack_public_path__ + "img/1577425176.ae832221.jpg";